import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from '@app-core/auth/guards/auth.guard';
import { NoAuthGuard } from '@app-core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

	// Redirect empty path to '/dashboard'
	{path: '', pathMatch : 'full', redirectTo: 'dashboard'},

	// Redirect signed-in user to the '/dashboard'
	//
	// After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
	// path. Below is another redirection for that path to redirect the user to the desired
	// location. This is a small convenience to keep all main routes together here on this file.
	{path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'dashboard'},

	// Auth routes for guests
	{
		path: '',
		canActivate: [NoAuthGuard],
		canActivateChild: [NoAuthGuard],
		component: LayoutComponent,
		data: {
			layout: 'empty'
		},
		children: [
			{path: 'forgot-password', loadChildren: () => import('@app-modules/auth/forgot-password/forgot-password.routes')},
			{path: 'reset-password', loadChildren: () => import('@app-modules/auth/reset-password/reset-password.routes')},
			{path: 'sign-in', loadChildren: () => import('@app-modules/auth/sign-in/sign-in.routes')},
		]
	},

	// Auth routes for authenticated users
	{
		path: '',
		canActivate: [AuthGuard],
		canActivateChild: [AuthGuard],
		component: LayoutComponent,
		data: {
			layout: 'empty'
		}
	},

	// Admin routes
	{
		path: '',
		canActivate: [AuthGuard],
		canActivateChild: [AuthGuard],
		component: LayoutComponent,
		resolve: {
			initialData: initialDataResolver
		},
		children: [
			{ path: 'profile', loadChildren: () => import('@app-modules/user/profile/profile.routes')},
			{ path: 'profile-company', loadChildren: () => import('@app-modules/user/profile/profile.routes') },
			{ path: 'company-profile', loadChildren: () => import('@app-modules/user/profile/profile.routes') },
			{ path: 'dashboard', loadChildren: () => import('@app-modules/admin/dashboard/dashboard.routes')},
			{ path: 'dashboard/invoice-detail/:id', loadChildren: () => import('@app-modules/admin/invoices/invoice-detail/invoice-detail.routes')},
			{ path: 'invoices', loadChildren: () => import('@app-modules/admin/invoices/invoices.routes')},
			{ path: 'invoices/detail/:id', loadChildren: () => import('@app-modules/admin/invoices/invoice-detail/invoice-detail.routes')},
			{ path: 'sales', loadChildren: () => import('@app-modules/admin/sales/sales.routes')},
			{ path: 'sales/detail/:id', loadChildren: () => import('@app-modules/admin/sales/sale-detail/sale-detail.routes')},
			{ path: 'products', loadChildren: () => import('@app-modules/user/products/products.routes') },
			{ path: 'products/detail/:id', loadChildren: () => import('@app-modules/user/products/products-detail/products-detail.routes') },
			{ path: 'dashboard/product-detail/:id', loadChildren: () => import('@app-modules/user/products/products-detail/products-detail.routes') },
			{ path: 'products-categories', loadChildren: () => import('@app-modules/user/products/products.routes') },
			{ path: 'products-categories/detail/:id', loadChildren: () => import('@app-modules/user/products/products-detail/products-detail.routes') },
			{ path: 'products-brands', loadChildren: () => import('@app-modules/user/products/products.routes') },
			{ path: 'products-brands/detail/:id', loadChildren: () => import('@app-modules/user/products/products-detail/products-detail.routes') },
			{ path: 'check-out/:uuid', loadChildren: () => import('@app-modules/user/check-out/check-out.routes') },
			{ path: 'branches', loadChildren: () => import('@app-modules/user/branches/branches.routes') },
			{ path: 'faqs', loadChildren: () => import('@app-modules/user/common-questions/common-questions.routes') },
			{ path: 'requests', loadChildren: () => import('@app-modules/user/requests/requests.routes')},
			{ path: 'requests/detail/:id', loadChildren: () => import( '@app-modules/user/requests/request-detail/request-detail.routes' ) },
			{ path: 'new-request', loadChildren: () => import('@app-modules/user/requests/request-form/request.form.routes') },
			{ path: 'credit', loadChildren: () => import('@app-modules/admin/credit/credit.routes')},
			{ path: 'credit/detail/:id', loadChildren: () => import('@app-modules/admin/invoices/invoice-detail/invoice-detail.routes')},
			{ path: 'payment-information', loadChildren: () => import('@app-modules/admin/payment-information/payment-information.routes')},
		]
	}
];
